import * as React from 'react';
import { message } from 'antd';
import { environment } from '@gaodun.com/gtools';
import { loadMicroApp } from 'qiankun';
import classNames from 'classnames';
import './index.less';
import queryDomMethods from '@/utils/queryDomMethods';

export interface IReportInfo {
    businessNote: any;
    createTime: number; // 时间 毫秒
    endTime: number; // 资源播放终止时间
    instanceId: string;
    position: number; // 资源位置
    roomId: any;
    sourceId: string;
    sourceType: number;
    speedNum: number; // 倍速
    startTime: number; // 资源播放开始时间
}
export enum IPlayerType {
    // video: { businessType: 100, sceneType: 120 }, // 学习视频，互动视频，回放
    // tiku: { businessType: 300, sceneType: 310 }, // timu
    // teacher: { businessType: 100, sceneType: 121 }, // 老师介绍
    // keZhong: { businessType: 100, sceneType: 170 }, // 课中
    // examKnowledge: { businessType: 100, sceneType: 170 }, // 考点图谱
    TIKU = 'tiku',
    VIDEO_NORMAL = 'video',
    VIDEO_SMRT_SCHOOL = 'video',
    VIDEO_LIVE_NEW = 'video',
    VIDEO_TEACHER = 'teacher',
    VIDEO_KNOWLEDGE = 'examKnowledge',
    VIDEO_KEING = 'keZhong',
}

interface IProps {
    playerType?: IPlayerType;
    title?: string;
    oncustomfinish?: false | (() => void);
    /** 进度发生变化 */
    ontimeupdate?: Function;
    canplay?: Function;
    onend?: Function;
    studentId?: string | number;
    onplay?: Function;
    onpause?: Function;
    videoId: string;
    onRef?: Function;
    markers?: any[];
    /** 当经过打点时间点的回调 */
    onMarkerReached?: (marker: any, index: number) => void;
    onFullscreenChange?: (isFull: boolean) => void;
    /** 弹幕的显示和隐藏监听 */
    onDanmakuChange?: (visiable: boolean) => void;
    // onConfigCallback?: (palyerConfig: IConfig) => void;
    businessNote?: any;
    isTrack?: boolean;
    trackApiParams?: {
        courseId: string | number;
        resourceId: string | number;
    };
}

function generateRandomString() {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let randomString = '';
    for (let i = 0; i < 8; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        randomString += characters.charAt(randomIndex);
    }
    return randomString;
}

class SubPlayer extends React.Component<IProps> {
    private g2player: any; // 定义播放器

    private lucaTrack: any; // 播放器时长记录

    private lucaChatRef: any;
    private containerId = `sub-player-load-${generateRandomString()}`;

    constructor(props: IProps) {
        super(props);
        this.state = {
            currentChapter: null,
        };
    }
    componentDidMount() {
        try {
            this.initQiankun();
            setTimeout(() => {
                // 获取目标元素
                const targetElement = queryDomMethods.querySelector(`#${this.containerId}`) || document.getElementById(this.containerId);
                // 设置高度为 100%
                if (targetElement) {
                    (targetElement as HTMLElement).style.height = '100%';
                }
            }, 1000);
        } catch (error) {
            // message.error('播放器初始化失败,请刷新页面重试');
            // eslint-disable-next-line no-alert
            alert('抱歉，不支持该视频的播放～');
        }
    }

    componentWillUnmount() {
        if (this.g2player) {
            // 这儿有个问题，当切换到普通播放模式时，再切换回来这会被null ，拿不到最新的实力
            this.g2player.destroy(); // 销毁播放器
            this.g2player = null;
        }
        if (this.lucaTrack) {
            this.lucaTrack.destroy();
            this.lucaTrack = null;
        }
        if (this.lucaChatRef) {
            this.lucaChatRef.unmount();
            this.lucaChatRef = null;
        }
    }

    initQiankun() {
        const { videoId, isTrack, businessNote, studentId } = this.props;

        const container = queryDomMethods.querySelector(`#${this.containerId}`) || document.getElementById(this.containerId);

        this.lucaChatRef = loadMicroApp(
            {
                name: 'sub-player-load',
                entry: `https://${environment.getApiEnv()}sub-study-player.gaodun.com/`, // 'http://dev-sub-study-player.gaodun.com:3038/
                container: container,
                props: {
                    videoId,
                    playerType: 'study',
                    businessType: 300, // 课程的意思
                    sceneType: 310,
                    autoplay: false,
                    isTrack,
                    businessNote,
                    userId: studentId,
                    // @ts-ignore
                    MS: window.MS,
                },
            },
            // 取消沙箱隔离
            { sandbox: { strictStyleIsolation: false } },
            {
                afterMount: async () => {},
                beforeUnmount: async () => {},
            }
        );
    }

    render() {
        return (
            <div className={classNames('sub-player-box')} style={{ height: '100%' }}>
                <div className="sub-player-root" id={this.containerId} style={{ height: '100%', background: 'black' }}></div>
            </div>
        );
    }
}

export default SubPlayer;
